import { Component, OnChanges,Input,Output,EventEmitter} from '@angular/core';
import { LoadingService } from '../../share/service/loading.service';
import { ApiService } from '../../share/service/api.service';
import { Router} from '@angular/router';
declare var jslib;
@Component({
  selector: 'eventItem',
  templateUrl: './eventItem.component.html'
})
export class eventItemComponent implements OnChanges 
{
  @Input() Data;
  @Output() Event = new EventEmitter();
  constructor(
    private pop : LoadingService,
    private baseapi : ApiService,
    private route : Router
  ) {
  }

  ngOnChanges() {
  }
}
